module.exports = __webpack_public_path__ + "static/media/ico_login_new.334168ac.svg";